import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import "../../styles/auth.scss";
import "../../styles/register.scss";
import { signUp } from "../constants/Validation";
import { Col, Container, FormCheck, Row, Spinner } from "react-bootstrap";
import { Texterror } from "../constants/Texterror";
import { imageUrls } from "../constants/images";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createUser } from "../redux/actions/authActions";

export const Register = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.UserNew);
  // Use useLocation to grab the query string
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const source = searchParams.get("source") || "";

  const handleRegister = (values) => {
    dispatch(createUser(values, history));
  };
  return (
    <div className="resitrar">
      <Container className="p-3">
        <Row className="d-flex justify-content-center align-items-center h-100">
          <Col>
            <div className="open_form">
              <div className="second_box">
                <img src={imageUrls.sihnup} alt="doctor" />
              </div>
              <div className="main_box">
                <div className="p-5 w-100 d-flex card-body flex-column">
                  <Link to={`/`}>
                    <img
                      src={imageUrls.logo}
                      className="img-fluid"
                      alt="Phone"
                    />
                  </Link>
                  <div className="mini_kog">
                    <h2 className="fw-bold mb-4 text-center">
                      Create a new Account
                    </h2>
                    <Formik
                      initialValues={{
                        user_email: "",
                        user_first_name: "",
                        user_last_name: "",
                        user_access_key: 1001,
                        user_active_yn: "Y",
                        user_password: "",
                        svc_provider_yn: "n",
                        role_id: "2",
                        conf_id: "1",
                        confirm_password: "",
                        referer: source,
                      }}
                      validationSchema={signUp}
                      onSubmit={(values, { resetForm }) => {
                        handleRegister(values);

                        resetForm();
                      }}
                    >
                      {({
                        values,
                        touched,
                        errors,
                        handleSubmit,
                        setFieldValue,
                        setTouched,
                      }) => (
                        <Form onSubmit={handleSubmit}>
                          <Row>
                            <Col lg={5}>
                              <div className="mb-2 new_margin">
                                <p>Who refered you to us? (optional)</p>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-2 new_margin">
                                <Field
                                  name="referer"
                                  className={`form-control ${
                                    touched.reference && errors.referer
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  placeholder="referer's email for finders fee!"
                                  type="text"
                                  size="lg"
                                  value={values.referer}
                                  disabled={source ? true : false}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={4}>
                              <div className="mb-2 new_margin">
                                <Field
                                  name="user_first_name"
                                  className={`form-control ${
                                    touched.user_first_name &&
                                    errors.user_first_name
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  placeholder="First Name"
                                  type="text"
                                  size="lg"
                                  value={values.user_first_name}
                                />
                                <ErrorMessage
                                  name="user_first_name"
                                  component={Texterror}
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="mb-2 new_margin">
                                <Field
                                  name="user_last_name"
                                  className={`form-control ${
                                    touched.user_last_name &&
                                    errors.user_last_name
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  placeholder="Last Name"
                                  type="text"
                                  value={values.user_last_name}
                                />
                                <ErrorMessage
                                  name="user_last_name"
                                  component={Texterror}
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="mb-2 new_margin">
                                <Field
                                  className={`form-control ${
                                    touched.user_email && errors.user_email
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  name="user_email"
                                  placeholder="Email"
                                  type="email"
                                  value={values.user_email}
                                />
                                <ErrorMessage
                                  name="user_email"
                                  component={Texterror}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6}>
                              <div className="mb-2 new_margin">
                                <Field
                                  name="user_password"
                                  className={`form-control ${
                                    touched.user_password &&
                                    errors.user_password
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  placeholder="Password"
                                  type="password"
                                  value={values.user_password}
                                />
                                <ErrorMessage
                                  name="user_password"
                                  component={Texterror}
                                />
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-2 new_margin">
                                <Field
                                  name="confirm_password"
                                  className={`form-control ${
                                    touched.confirm_password &&
                                    errors.confirm_password
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  placeholder="Confirm Password"
                                  type="password"
                                  size="lg"
                                />
                                <ErrorMessage
                                  name="confirm_password"
                                  component={Texterror}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row className="justify-content-center">
                            <Col lg={8}>
                              <div className="op mb-2">
                                <FormCheck
                                  name="svc_provider_yn"
                                  label="Are you a Service Provider with facilities in Zimbabwe?"
                                  checked={values.svc_provider_yn === "y"}
                                  type="checkbox"
                                  onChange={(e) => {
                                    setFieldValue(
                                      "svc_provider_yn",
                                      e.target.checked ? "y" : "n"
                                    );
                                  }}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="text-center new_margin">
                              <button type="submit" className="sign_btn mb-4">
                                {isLoading ? (
                                  <>
                                    <Spinner />
                                  </>
                                ) : (
                                  "Sign Up"
                                )}
                              </button>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>

                    <div className="newlane mb-4"></div>
                    <p className="text-center">
                      Already have an account?{" "}
                      <Link className="forgot" to={`/login`}>
                        Sign In Here
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
